import { Model, ModelAttributes, model, modelConfig, reference } from "@mixitone/oom";
import { setAccountId } from "./concerns/SetAccountId";
import Account from "./Account";
import FundingOutreachCommunication from "./FundingOutreachCommunication";
import { Database } from "./database.types";

const config = modelConfig(
  {
    account_id: {
      type: "string",
    },
    analyzed_at: {
      type: "datetime",
    },
    created_at: {
      type: "datetime",
    },
    funding_outreach_communication_id: {
      type: "string",
    },
    is_deleted: {
      type: "boolean",
    },
    raw_response: {
      type: "json",
      jsonType: null,
    },
    sentiment: {
      type: "enum",
      enumType: "" as Database["public"]["Enums"]["funding_outreach_reply_sentiment"],
    },
    summary: {
      type: "string",
    },
    updated_at: {
      type: "datetime",
    },
  },
  {},
  {
    account: reference(() => Account as any, "account_id"),
    funding_outreach_communication: reference(
      () => FundingOutreachCommunication as any,
      "funding_outreach_communication_id",
    ),
  },
);

interface FundingOutreachCommunicationAnalysis extends ModelAttributes<typeof config> {}

@setAccountId
@model("funding_outreach_communication_analyses", config)
class FundingOutreachCommunicationAnalysis extends Model<typeof config> {}

export default FundingOutreachCommunicationAnalysis;
